module.exports = __webpack_public_path__ + "static/media/file.0b8d9755.svg";